export const GET_FILES_LIST = "GET_FILES_LIST";
export const SELECTED_FILES = "SELECTED_FILES";
export const DELETE_EXTENSION_FILE = "DELETE_EXTENSION_FILE";
export const DELETE_EXTENSION_NOTE = "DELETE_EXTENSION_NOTE";
export const ADD_EXTENSION_TAB = "ADD_EXTENSION_TAB";
